import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import './css/fontawesome.css';
import './css/index.css';
import './css/tailwind-output.css';

import Home from "./pages/Home";
import Privacy from "./pages/Privacy";
import Faq from "./pages/Faq";
import Orleans from "./pages/Orleans";
import OndeAtendemos from "./pages/OndeAtendemos";
import ServicePage from "./components/ServicePage";
import { servicos } from "./components/data/servicos";
import { locais } from "./components/data/locais";
import NotFound from "./pages/NotFound";

const container = document.getElementById("root");
const app = (
  <Router>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/privacidade" element={<Privacy />} />
      <Route path="/perguntas-frequentes" element={<Faq />} />
      <Route path={locais.orleans.slug} element={<Orleans />} />
      <Route path={locais.regiao.slug} element={<OndeAtendemos />} />
      <Route path={servicos.software.slug} element={<ServicePage servico={servicos.software} />} />
      <Route path={servicos.automacao.slug} element={<ServicePage servico={servicos.automacao} />} />
      <Route path={servicos.diagnostico.slug} element={<ServicePage servico={servicos.diagnostico} />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </Router>
);

if (container.hasChildNodes()) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
